/*
 * @Author: Dom
 * @Date: 2022-05-18 18:14:45
 * @LastEditTime: 2022-05-31 15:15:51
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\component\phone\locales\zh-CN.ts
 */
export default {
    'page.personal.center.compontent.bindphone.tips' : '输入绑定手机号',
    'page.personal.center.compontent.codenumber.tips' : '输入图形验证码',
    'page.personal.center.compontent.msgnumber.tips' : '输入短信验证码',
    'page.personal.center.compontent.password.tips' : '输入登录密码',
    'page.personal.center.compontent.phone.btnconfirm' : '确认绑定',
    'page.personal.center.compontent.phone.btnconfirm.change' : '确认修改',
    'page.personal.center.compontent.phone.required' : '手机号码不能为空',
    'page.personal.center.compontent.btnctrl' : '取消',
    'page.personal.center.compontent.close' : '关闭',
    'page.personal.center.compontent.btnchangetxt':'换一换',
    'page.personal.center.compontent.verificationtxt':'获取验证码',
    'page.personal.center.compontent.verificationtxtrepeat':'重新获取验证码',
    'page.personal.center.compontent.bindsuccess':'手机号码绑定成功!',
    'page.personal.center.compontent.countdown.tips':'秒后重新发送',
}
